import React from "react";
import { Divider, Typography } from "antd";

const FormDividerCenter = ({ title, ...props }) => (
  <Divider className="form-divider" orientation="center" {...props}>
    <div className="form-divider-text">{props.children}</div>
  </Divider>
);
export default FormDividerCenter;
